import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useToast } from '@/shared/hooks/useToast'
import { onPwaUpdateAvailable } from '@/shared/lib/pwaUpdate'

export function PwaUpdatePrompt() {
  const { t } = useTranslation()
  const { showToast } = useToast()

  useEffect(
    () =>
      onPwaUpdateAvailable(({ reload }) => {
        showToast({
          kind: 'info',
          title: t('ui.pwa.update_title'),
          description: t('ui.pwa.update_description'),
          actionLabel: t('ui.pwa.update_reload'),
          onAction: reload,
        })
      }),
    [showToast, t],
  )

  return null
}
